var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreferenceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1421 5.16347C15.6465 2.0279 12.5641 0.0463487 9.09446 0.000795678C5.61724 -0.0447573 2.53483 1.86847 0.986025 5.01162C-0.623513 8.26866 -0.243905 12.042 1.98819 14.8738L7.75064 22.1927C8.04674 22.5647 8.48708 22.7773 8.9578 22.7773C9.42851 22.7773 9.86886 22.5647 10.165 22.1927L16.0792 14.6764C18.2278 11.9433 18.6302 8.30662 17.1421 5.17106V5.16347ZM14.8949 13.735L8.9502 21.2513L3.18775 13.9324C1.32767 11.5713 1.0088 8.40532 2.35261 5.68733C3.64328 3.07562 6.11073 1.52682 8.96539 1.52682H9.07927C12.0098 1.57237 14.5153 3.17432 15.7756 5.82399C17.0359 8.47365 16.7094 11.427 14.8949 13.735Z",
    fill: "#4F4A62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95782 4.67773C6.67258 4.67773 4.8125 6.53781 4.8125 8.82306C4.8125 11.1083 6.67258 12.9684 8.95782 12.9684C11.2431 12.9684 13.1031 11.1083 13.1031 8.82306C13.1031 6.53781 11.2431 4.67773 8.95782 4.67773ZM8.95782 11.4424C7.50772 11.4424 6.33093 10.2656 6.33093 8.81546C6.33093 7.36536 7.50772 6.18857 8.95782 6.18857C10.4079 6.18857 11.5847 7.36536 11.5847 8.81546C11.5847 10.2656 10.4079 11.4424 8.95782 11.4424Z",
    fill: "#4F4A62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferenceIcon);
export default __webpack_public_path__ + "static/media/preference-icon.4ce0bc0a36879f6909402bdcfd3905bd.svg";
export { ForwardRef as ReactComponent };